import { createWebHistory, createRouter, RouteRecordRaw } from "vue-router";
import { authGuard, scopeGuard, redirectToLoginGuard, multiGuards } from "./routerHelper";
import { ACCOUNT_OPERATION } from "./types";
import { useLocalStorageStore } from "@/stores/localStorage"

const CandidatePauseRenew = () => import ("../components/CandidatePauseRenew.vue");

const LogoutComponent = () => import ('../login/Logout.vue');

//Landing Pages
const Landingpage = () => import ("../landingpages/Landingpage.vue");
const Direct = () => import("../registration/Direct.vue");

//Authenticated Candidate Pages
const Dashboard = () => import ("../dashboard/Dashboard.vue");
const Profile = () => import ("../profile/Profile.vue");

//Requests Pages
const Requests = () => import("../requests/Requests.vue");

// Authenticated Candidate Settings
const Settings = () => import ("../settings/Settings.vue");

//Footer pages
const PrivacyPolicy = () => import ('../components/PrivacyPolicy.vue');

//Error pages
const PageNotFound = () => import ('../errorpages/PageNotFound.vue');

const routes: RouteRecordRaw[] = [
    {
        path: "/kandidaten",
        redirect: { name: "Home" },
        children: [
            // NO LOGIN REQUIRED
            {
                path: "direct",
                name: "Direct",
                component: Direct,
            },
            {
                path: "pause",
                name: "Pause",
                component: CandidatePauseRenew,
                props: { operation: ACCOUNT_OPERATION.PAUSE },
            },
            {
                path: "renew",
                name: "Renew",
                component: CandidatePauseRenew,
                props: { operation: ACCOUNT_OPERATION.RENEW },
            },
            {
                path: "finance",
                name: "Finance",
                redirect: { name: "FinanceLogin" },
                beforeEnter: (to, from, next) => {
                    useLocalStorageStore().setScope("FINANCE")
                    next()
                },
                children: [
                    {
                        path: "login",
                        name: "FinanceLogin",
                        component: Landingpage,
                        props: { dialog: "login" },
                    },
                    {
                        path: "register",
                        name: "FinanceRegister",
                        component: Landingpage,
                        props: { dialog: "register" },
                    }
                ]
            },
            {
                path: "tech",
                name: "Tech",
                redirect: { name: "TechLogin" },
                beforeEnter: (to, from, next) => {
                    useLocalStorageStore().setScope("TECH")
                    next()
                },
                children: [
                    {
                        path: "login",
                        name: "TechLogin",
                        component: Landingpage,
                        props: { dialog: "login" },
                    },
                    {
                        path: "register",
                        name: "TechRegister",
                        component: Landingpage,
                        props: { dialog: "register" },
                    }
                ]
            },

            // LOGIN REQUIRED
            {
                path: "dashboard",
                name: "Dashboard",
                component: Dashboard,
                beforeEnter: multiGuards([scopeGuard, authGuard])
            },
            {
                path: "profile",
                name: "Profile",
                component: Profile,
                beforeEnter: multiGuards([scopeGuard, authGuard])
            },
            {
                path: "settings",
                name: "Settings",
                component: Settings,
                beforeEnter: multiGuards([scopeGuard, authGuard]),
            },
            {
                path: "requests",
                name: "Requests",
                redirect: { name: "OpenRequests" },
                beforeEnter: multiGuards([scopeGuard, authGuard]),
                children: [
                    {
                        path: "open",
                        name: "OpenRequests",
                        component: Requests,
                        props: { filter: 'open' }
                    },
                    {
                        path: "confirmed",
                        name: "ConfirmedRequests",
                        component: Requests,
                        props: { filter: 'confirmed' }
                    },
                    {
                        path: "favorites",
                        name: "FavoriteRequests",
                        component: Requests,
                        props: { filter: 'favorites' }
                    },
                ],
            },

            // COMMONS
            {
                path: 'logout',
                name: 'Logout',
                component: LogoutComponent,
                beforeEnter: scopeGuard
            },
            {
                path: 'datenschutz',
                name: 'PrivacyPolicy',
                component: PrivacyPolicy,
            },
            {
                path: '404',
                name: 'PageNotFound',
                component: PageNotFound,
            },
        ],
    },

    // REDIRECTS
    {
        path: "/",
        name: "Home",
        component: Landingpage,
        beforeEnter: redirectToLoginGuard
    },
    {
        path: '/:catchAll(.*)*',
        redirect: { name: 'PageNotFound' },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});


export default router;
